import React from 'react';
import TauriNavigation from '../TauriNavigation/TauriNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import './TauriLayout.css';

const TauriLayout = ({ children }) => {

  return (
    <div className='layout'>
      <TauriNavigation />

      <div className="container-fluid">
        {children}
      </div>
    </div>
  );
};

export default TauriLayout;
